'use strict';
import angular from 'angular';

angular.module('tasks.services', [])
    .service('TaskService', TaskService)
    .service('TaskFactory', TaskFactory);

TaskService.$inject = ['TaskFactory', '$q'];

function TaskService(TaskFactory, $q) {
    var service = {};
    service.lineItems = [];
    service.taskAssignments = [];
    service.taskAssignment = null;
    service.taskAssignmentPriority = null;
    service.task = null;
    service.tasksList = null;
    service.taskFollower = null;
    service.Timelog = null;
    service.taskAssignmentHistory = [];

    //Get Task Assignment History
    service.getTaskAssignmentHistory = function(task_id) {
        var deferred = $q.defer();
        TaskFactory.getTaskAssignmentHistory(task_id).get().$promise.then(function(data) {
            deferred.resolve(data.data);
        }, function(response) {
            console.log("Error getting tasks due date dependencies ");
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all task assignments in a queue
    service.getTaskAssignmentsForQueue = function(queueId, clusterId) {
        var deferred = $q.defer();
        var params = { 'queueId': queueId };

        if (clusterId) {
            params.clusterId = clusterId;
        }

        TaskFactory.taskAssignmentsForQueue().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve();
        }, function(response) {
            console.log("Error getting task assignments for queue " + queueId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getOpenLineItemsForTask = function(taskId) {
        var deferred = $q.defer();
        var params = { 'id': taskId };

        TaskFactory.openLineItems().get(params).$promise.then(function(data) {
            service.lineItems = data.lineItems || [];
            deferred.resolve();
        }, function(response) {
            console.log("Error getting Line Items for task " + queueId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.canCompleteTask = function(taskId) {
        var deferred = $q.defer();
        var params = { 'id': taskId };

        TaskFactory.canCompleteTask().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log(response);
            deferred.reject(response);
        });
        return deferred.promise;
    };

    // Get all active task assignments in a queue
    service.getActiveTaskAssignmentsForQueue = function(params) {
        let deferred = $q.defer();

        TaskFactory.activeTaskAssignmentsForQueue().save(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve();
        }, function() {
            console.log("Error getting task assignments for queue " + queueId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all task assignments assigned to user
    service.getTaskAssignmentsForCurrentUser = function(clusterId) {
        var deferred = $q.defer();
        var params = {};

        if (clusterId) {
            params.clusterId = clusterId;
        }

        TaskFactory.taskAssignmentsForCurrentUser().save(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve();
        }, function(response) {
            console.log("Error getting task assignments for current user");
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get open task assignments assigned to user
    service.getOpenTaskAssignmentsForCurrentUser = function(params) {
        let deferred = $q.defer();

        TaskFactory.openTaskAssignmentsForCurrentUser().save(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments.rows || [];
            deferred.resolve(data);
        }, function() {
            console.log("Error getting open task assignments for current user");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getClosedTaskAssignmentsForCurrentUser = function(params) {
        var deferred = $q.defer();
        /*var params = {};
        if (clusterId) {
            params.clusterId = clusterId;
        }*/

        TaskFactory.closedTaskAssignmentsForCurrentUser().save(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments.rows || [];
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting open task assignments for current user");
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get task assignments followed by the current user
    service.getFollowedTaskAssignmentsForCurrentUser = function(params) {
        let deferred = $q.defer();

        TaskFactory.followedTaskAssignmentsForCurrentUser().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data);
        }, function() {
            console.log("Error getting task assignments followed by current user");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getOnDemandTasksForClient = function(clusterId) {
        var deferred = $q.defer();
        var params = { 'clusterId': clusterId };

        TaskFactory.onDemandTasksForClient().get(params).$promise.then(function(data) {
            service.onDemandTasks = data.onDemandTasks || [];
            deferred.resolve(data.onDemandTasks || []);
        }, function(response) {
            console.log("Error getting client on demand tasks for cluster " + clusterId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all on demand tasks for an order
    service.getOnDemandTasksForOrder = function(workflowId) {
        var deferred = $q.defer();
        var params = { 'workflowId': workflowId };

        TaskFactory.onDemandTasksForOrder().get(params).$promise.then(function(data) {
            service.onDemandTasks = data.onDemandTasks || [];
            deferred.resolve(data.onDemandTasks || []);
        }, function(response) {
            console.log("Error getting on demand tasks for workflow " + workflowId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all on demand tasks for a product
    service.getOnDemandTasksForProduct = function(productId) {
        var deferred = $q.defer();
        var params = { 'productId': productId };

        TaskFactory.onDemandTasksForProduct().get(params).$promise.then(function(data) {
            service.onDemandTasks = data.onDemandTasks || [];
            deferred.resolve(data.onDemandTasks || []);
        }, function(response) {
            console.log("Error getting task assignments for product " + productId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all on demand tasks for flights under a product
    service.getOnDemandTasksForFlight = function(productId) {
        var deferred = $q.defer();
        var params = { 'productId': productId };

        TaskFactory.onDemandTasksForFlight().get(params).$promise.then(function(data) {
            service.onDemandTasks = data.onDemandTasks || [];
            deferred.resolve(data.onDemandTasks || []);
        }, function(response) {
            console.log("Error getting task assignments for flights under product " + productId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getTaskAssignmentsForClient = function(clientId) {
        var deferred = $q.defer();
        var params = { 'clientId': clientId };

        TaskFactory.taskAssignmentsForClient().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data.taskAssignments || []);
        }, function(response) {
            console.log("Error getting task assignments for client " + clientId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all task assignments for an order
    service.getTaskAssignmentsForOrder = function(orderId) {
        var deferred = $q.defer();
        var params = { 'orderId': orderId };

        TaskFactory.taskAssignmentsForOrder().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data.taskAssignments || []);
        }, function(response) {
            console.log("Error getting task assignments for order " + orderId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getOpenTaskAssignmentsForClient = function(clientId) {
        var deferred = $q.defer();
        var params = { 'clientId': clientId };

        TaskFactory.openTaskAssignmentsForClient().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data.taskAssignments || []);
        }, function(response) {
            console.log("Error getting open task assignments for client " + clientId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get open task assignments for an order
    service.getOpenTaskAssignmentsForOrder = function(orderId) {
        var deferred = $q.defer();
        var params = { 'orderId': orderId };

        TaskFactory.openTaskAssignmentsForOrder().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data.taskAssignments || []);
        }, function(response) {
            console.log("Error getting open task assignments for order " + orderId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all task assignments for a line item
    service.getTaskAssignmentsForLineItem = function(lineItemId) {
        var deferred = $q.defer();
        var params = { 'lineItemId': lineItemId };

        TaskFactory.taskAssignmentsForLineItem().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data.taskAssignments || []);
        }, function(response) {
            console.log("Error getting task assignments for line item " + lineItemId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get open task assignments for a line item
    service.getOpenTaskAssignmentsForLineItem = function(lineItemId) {
        var deferred = $q.defer();
        var params = { 'lineItemId': lineItemId };

        TaskFactory.openTaskAssignmentsForLineItem().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data.taskAssignments || []);
        }, function(response) {
            console.log("Error getting open task assignments for line item " + lineItemId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all task assignments for a flight
    service.getTaskAssignmentsForFlight = function(flightId) {
        var deferred = $q.defer();
        var params = { 'flightId': flightId };

        TaskFactory.taskAssignmentsForFlight().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data.taskAssignments || []);
        }, function(response) {
            console.log("Error getting task assignments for flight " + flightId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get open task assignments for a flight
    service.getOpenTaskAssignmentsForFlight = function(flightId) {
        var deferred = $q.defer();
        var params = { 'flightId': flightId };

        TaskFactory.openTaskAssignmentsForFlight().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data.taskAssignments || []);
        }, function(response) {
            console.log("Error getting open task assignments for flight " + flightId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get a single task assignment
    service.getTaskAssignment = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.taskAssignment().get(params).$promise.then(function(data) {
            service.taskAssignment = data.taskAssignment;
            deferred.resolve();
        }, function(response) {
            deferred.reject({message: response.data.message, code: response.status});
        });
        return deferred.promise;
    };

    //Get List of Tasks
    service.getTasksList = function(clusterId) {
        var deferred = $q.defer();
        var params = {};
        if (clusterId) {
            params.clusterId = clusterId;
        }
        TaskFactory.tasks().get(params).$promise.then(function(data) {
            service.tasksList = data.tasks;
            deferred.resolve(data.tasks);
        }, function(response) {
            console.log("Error getting tasks ");
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get a single task
    service.getTask = function(taskId) {
        var deferred = $q.defer();
        var params = { 'id': taskId };

        TaskFactory.task().get(params).$promise.then(function(data) {
            service.task = data.task;
            deferred.resolve();
        }, function(response) {
            console.log("Error getting task " + taskId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.saveTask = function(taskObj) {
        var deferred = $q.defer();

        TaskFactory.task().save(taskObj).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error Saving task " + taskId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.updateTask = function(taskObj) {
        var deferred = $q.defer();

        TaskFactory.task().update(taskObj).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error Saving task " + taskId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Assign a task assignment to a user
    service.assignTaskAssignment = function(taskAssignmentId, userId) {
        var deferred = $q.defer();
        var params = {
            'id': taskAssignmentId,
            'userId': userId
        };

        TaskFactory.assignTaskAssignment().update(params).$promise.then(function(data) {
            service.taskAssignment = data.taskAssignment;
            deferred.resolve();
        }, function(response) {
            console.log("Error assigning task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Assign task assignments to a user
    service.assignTaskAssignments = function(taskAssignmentIds, userId) {
        var deferred = $q.defer();
        var params = {
            'taskAssignmentIds': taskAssignmentIds,
            'userId': userId
        };

        TaskFactory.assignTaskAssignments().update(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments;
            deferred.resolve(data.taskAssignments);
        }, function(response) {
            console.log("Error assigning task assignments " + taskAssignmentIds);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Start multiple task assignments
    service.startTaskAssignments = function(taskAssignmentIds) {
        var deferred = $q.defer();
        var params = { 'taskAssignmentIds': taskAssignmentIds };

        TaskFactory.startTaskAssignments().update(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments;
            deferred.resolve();
        }, function(response) {
            console.log("Error starting task assignments " + taskAssignmentIds);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Complete multiple task assignments
    service.completeTaskAssignments = function(taskAssignmentIds) {
        var deferred = $q.defer();
        var params = { 'taskAssignmentIds': taskAssignmentIds };

        TaskFactory.completeTaskAssignments().update(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments;
            service.errors = data.errors;
            deferred.resolve();
        }, function(response) {
            console.log("Error completing task assignments " + taskAssignmentIds);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.updateTaskAssignmentQueue = function(taskAssignmentId, queueId) {
        var deferred = $q.defer();
        var params = {
            'id': taskAssignmentId,
            'queueId': queueId
        };

        TaskFactory.assignTaskToQueue().update(params).$promise.then(function(data) {
            if(data.taskAssignment) {
                service.taskAssignmentQueue = data.taskAssignment;
                deferred.resolve(data.taskAssignment);
            }else {
                deferred.reject(data.errors);
            }
        }, function(error) {
            console.log("Error assigning task to queue " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.updateTaskAssignmentsQueue = function(taskAssignmentIds, queueId) {
        var deferred = $q.defer();
        var params = {
            'taskAssignmentIds': taskAssignmentIds,
            'queueId': queueId
        };

        TaskFactory.assignTasksToQueue().update(params).$promise.then(function(data) {
            if (data.errors) {
                service.errors = data.errors;
            } else {
                service.taskAssignmentsQueue = data.taskAssignments;
            }
            deferred.resolve(data);
        }, function(error) {
            console.log("Error assigning task to queue " + taskAssignmentIds);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Assign a task assignment to the current logged in user
    service.assignToCurrentUser = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.assignToCurrentUser().update(params).$promise.then(function(data) {
            service.taskAssignment = data.taskAssignment;
            deferred.resolve();
        }, function(response) {
            console.log("Error assigning task assignment to current user " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Unassign a task assignment
    service.unassign = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.unassignTaskAssignment().update(params).$promise.then(function(data) {
            service.taskAssignment = data.taskAssignment;
            deferred.resolve();
        }, function(response) {
            console.log("Error unassigning task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Follow the specified task assignment
    service.followTaskAssignment = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.followTaskAssignment().save(params).$promise.then(function(data) {
            service.taskFollower = data.taskFollower;
            deferred.resolve();
        }, function(response) {
            console.log("Error following task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Follow the specified task assignments
    service.followTaskAssignments = function(taskAssignmentIds) {
        var deferred = $q.defer();
        var params = { 'taskAssignmentIds': taskAssignmentIds };

        TaskFactory.followTaskAssignments().save(params).$promise.then(function(data) {
            service.taskFollowers = data.taskFollowers;
            deferred.resolve();
        }, function(response) {
            console.log("Error following task assignments " + taskAssignmentIds);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Unfollow the specified task assignment
    service.unfollowTaskAssignment = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.unfollowTaskAssignment().save(params).$promise.then(function(data) {
            service.taskFollower = data.taskFollower;
            deferred.resolve();
        }, function(response) {
            console.log("Error unfollowing task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Unfollow the specified task assignments
    service.unfollowTaskAssignments = function(taskAssignmentIds) {
        var deferred = $q.defer();
        var params = { 'taskAssignmentIds[]': taskAssignmentIds };

        TaskFactory.unfollowTaskAssignments().save(params).$promise.then(function(data) {
            service.taskFollower = data.taskFollower;
            deferred.resolve();
        }, function(response) {
            console.log("Error unfollowing task assignments " + taskAssignmentIds);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Mark a task assignment as complete
    service.completeTaskAssignment = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.completeTaskAssignment().update(params).$promise.then(function(data) {
            if (data.errors) {
                service.errors = data.errors;
            } else {
                service.taskAssignment = data.taskAssignment;
            }
            deferred.resolve();
        }, function(response) {
            console.log("Error completing task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Mark a task assignment as rejected
    service.rejectTaskAssignment = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.rejectTaskAssignment().update(params).$promise.then(function(data) {
            service.taskAssignment = data.taskAssignment;
            deferred.resolve();
        }, function(response) {
            console.log("Error rejecting task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Increment task assignment priority by one
    service.incrementTaskAssignmentPriority = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.incrementTaskAssignmentPriority().update(params).$promise.then(function(data) {
            service.taskAssignmentPriority = data.priority;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error incrementing priority of task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Increment task assignments priority by one
    service.incrementTaskAssignmentsPriority = function(taskAssignmentIds) {
        var deferred = $q.defer();
        var params = { 'taskAssignmentIds': taskAssignmentIds };

        TaskFactory.incrementTaskAssignmentsPriority().update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error incrementing priority of task assignments " + taskAssignmentIds);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Decrement task assignment priority by one
    service.decrementTaskAssignmentPriority = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = { 'id': taskAssignmentId };

        TaskFactory.decrementTaskAssignmentPriority().update(params).$promise.then(function(data) {
            service.taskAssignmentPriority = data.priority;
            deferred.resolve(data);
        }, function(response) {
            console.log("Error decrementing priority of task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Decrement task assignments priority by one
    service.decrementTaskAssignmentsPriority = function(taskAssignmentIds) {
        var deferred = $q.defer();
        var params = { 'taskAssignmentIds': taskAssignmentIds };

        TaskFactory.decrementTaskAssignmentsPriority().update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error decrementing priority of task assignments " + taskAssignmentIds);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Push data to a vendor integration
    service.executeVendorPush = function(taskAssignmentId, lineItemId, vendorName, flightId, clientId) {
        var deferred = $q.defer();
        var params = {
            'id': taskAssignmentId,
            'lineItemId': lineItemId,
            'vendorName': vendorName,
        };

        if (flightId) {
            params['flightId'] = flightId;
        }

        if (clientId) {
            params['clientId'] = clientId;
        }

        TaskFactory.executeVendorPush().update(params).$promise.then(function(data) {
            service.taskAssignment = data.taskAssignment;
            deferred.resolve();
        }, function(response) {
            console.log("Error pushing vendor data for task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // Push goal 
    service.executeGoalPush = function(taskAssignmentId, itemType) {
        const deferred = $q.defer();
        const params = {
            'id': taskAssignmentId,
            'itemType': itemType,
        };

        TaskFactory.executeGoalPush().update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error pushing goal data for task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.processWebhookEvents = function(taskAssignmentId, entityType, entityId, eventNames) {
        var deferred = $q.defer();
        var params = {
            'id': taskAssignmentId,
            'entityType': entityType,
            'entityId': entityId
        };

        if (eventNames) {
            params['eventNames'] = eventNames;
        }

        TaskFactory.processWebhookEvents().update(params).$promise.then(function(data) {
            service.taskAssignment = data.taskAssignment;
            deferred.resolve();
        }, function(response) {
            console.log("Error processing webhook events for task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getReferenceTables = function() {
        var deferred = $q.defer();
        TaskFactory.referenceTables().get().$promise.then(function(data) {
            deferred.resolve(data.referenceTables);
        }, function(response) {
            console.log("Error loading reference tables");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getVendorsList = function() {
        var deferred = $q.defer();
        TaskFactory.vendorsList().get().$promise.then(function(data) {
            deferred.resolve(data.vendors);
        }, function(response) {
            console.log("Error loading reference tables");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getClosedTaskAssignments = function(params) {
        var deferred = $q.defer();
        /*var params = {};

        if (clusterId) {
            params.clusterId = clusterId;
        }*/

        TaskFactory.closedTaskAssignments().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data);
        }, function(response) {
            console.log("Error loading closed task assignments");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getTasksStatus = function() {
        var deferred = $q.defer();
        TaskFactory.tasksStatus().get().$promise.then(function(data) {
            deferred.resolve(data.statuses);
        }, function(response) {
            console.log("Error loading task status");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.updateTaskStatus = function(param) {
        var deferred = $q.defer();
        TaskFactory.taskStatusUpdate().update(param).$promise.then(function(data) {
            deferred.resolve(data.task);
        }, function(response) {
            console.log("Error loading task status");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getOpenTaskAssignments = function(params) {
        var deferred = $q.defer();
        /*var params = {};

        if (clusterId) {
            params.clusterId = clusterId;
        }*/

        TaskFactory.openTaskAssignments().get(params).$promise.then(function(data) {
            service.taskAssignments = data.taskAssignments || [];
            deferred.resolve(data);
        }, function(response) {
            console.log("Error loading open task assignments");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.toggleTaskState = function(params) {
        var deferred = $q.defer();

        TaskFactory.toggleTaskState().update(params).$promise.then(function(data) {
            deferred.resolve(data.task);
        }, function(response) {
            console.log("Error updating task state");
            deferred.reject();
        });
        return deferred.promise;
    };

    //Get List of TasksAssignmentTimelog
    service.taskAssignmentTimelog = function(taskAssignmentId) {
        var deferred = $q.defer();
        var params = {};
        params.taskAssignmentId = taskAssignmentId;

        TaskFactory.taskAssignmentTimelog().get(params).$promise.then(function(data) {
            service.Timelog = data.taskAssignmentTimelog;
            deferred.resolve();
        }, function(response) {
            console.log("Error getting Task Assignment Timelog ");
            deferred.reject();
        });
        return deferred.promise;
    };

    // add time to timelog for taskassignment
    service.logTimeForTask = function(taskAssignmentId, hour, minute) {
        var deferred = $q.defer();
        var params = {
            'id': taskAssignmentId,
            'hour': hour,
            'minute': minute
        };

        TaskFactory.logTimeForTask().update(params).$promise.then(function(data) {
            service.Timelog = data.taskAssignmentTimelog;
            deferred.resolve();
        }, function(response) {
            console.log("Error updating time for task assignment " + taskAssignmentId);
            deferred.reject();
        });
        return deferred.promise;
    };

    // add time to timelog for taskassignment
    service.deleteTimelogEntry = function(TlId, TId) {
        var deferred = $q.defer();
        var params = {
            'tlid': TlId,
            'tid': TId
        };

        TaskFactory.deleteTimelogEntry().update(params).$promise.then(function(data) {

            service.Timelog = data.taskAssignmentTimelog;
            service.getTaskAssignment(TId).then(function(success) {
                deferred.resolve();
            });


        }, function(response) {
            console.log("Error deleting time for task assignment log " + rowid);
            deferred.reject();
        });
        return deferred.promise;
    };

    //Get List of Tasks WithoutTaskForm
    service.getTasksWithoutTaskForm = function(clusterId) {
        var deferred = $q.defer();
        var params = {};
        if (clusterId) {
            params.clusterId = clusterId;
        }
        TaskFactory.getTasksWithoutTaskForm().get(params).$promise.then(function(data) {
            deferred.resolve(data.tasks);
        }, function(response) {
            console.log("Error getting tasks Without Task Form ");
            deferred.reject();
        });
        return deferred.promise;
    };

    //Get Task Due Date Dependecies
    service.getDueDateDependencies = function() {
        var deferred = $q.defer();
        TaskFactory.dueDateDependencies().get().$promise.then(function(data) {
            deferred.resolve(data.taskDueDateDependencies);
        }, function(response) {
            console.log("Error getting tasks due date dependencies ");
            deferred.reject();
        });
        return deferred.promise;
    };

    //Get Task Due Date Dependecies
    service.updateDueDate = function(obj) {
        var deferred = $q.defer();
        TaskFactory.updateTaskDueDate().update({ 'updateDueDate': 'updateDueDate' }, obj).$promise.then(function(data) {
            deferred.resolve(data.taskAssignment);
        }, function(response) {
            console.log("Error getting tasks due date dependencies ");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.updateMultipleDueDates = function(obj) {
        var deferred = $q.defer();
        TaskFactory.updateTaskDueDate().update({ 'updateDueDate': 'updateDueDates' }, obj).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting tasks due date dependencies ");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.addCalendarEvent = function(taskAssignmentId) {
        var deferred = $q.defer();

        TaskFactory.addCalendarEvent(taskAssignmentId).get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.hasCalendarEvent = function(taskAssignmentId) {
        var deferred = $q.defer();

        TaskFactory.hasCalendarEvent(taskAssignmentId).get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    return service;
}

TaskFactory.$inject = ['$resource', 'AppConfig'];

function TaskFactory($resource, AppConfig) {
    var factory = {};

    factory.taskAssignmentsForQueue = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/taskAssignmentsForQueue', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.activeTaskAssignmentsForQueue = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/activeTaskAssignmentsForQueue', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.taskAssignmentsForCurrentUser = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/taskAssignmentsForCurrentUser', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.openTaskAssignmentsForCurrentUser = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/openTaskAssignmentsForCurrentUser', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.closedTaskAssignmentsForCurrentUser = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/closedTaskAssignmentsForCurrentUser', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.followedTaskAssignmentsForCurrentUser = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/followedTaskAssignmentsForCurrentUser', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.onDemandTasksForClient = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/onDemandTasksForClient', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.onDemandTasksForOrder = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/onDemandTasksForOrder', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.onDemandTasksForProduct = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/onDemandTasksForProduct', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.onDemandTasksForFlight = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/onDemandTasksForFlight', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskAssignmentsForClient = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/taskAssignmentsForClient', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskAssignmentsForOrder = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/taskAssignmentsForOrder', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.openTaskAssignmentsForClient = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/openTaskAssignmentsForClient', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.openTaskAssignmentsForOrder = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/openTaskAssignmentsForOrder', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskAssignmentsForLineItem = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/taskAssignmentsForLineItem', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.openTaskAssignmentsForLineItem = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/openTaskAssignmentsForLineItem', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskAssignmentsForFlight = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/taskAssignmentsForFlight', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.openTaskAssignmentsForFlight = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/openTaskAssignmentsForFlight', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskAssignment = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/taskAssignment', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskAssignmentTimelog = function() {
        return $resource(AppConfig.IO_API_URL + 'taskAssignmentTimelog', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.tasks = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.task = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/task', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.assignTaskAssignment = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/assignToUser', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.assignTaskAssignments = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/assignTaskAssignments', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.startTaskAssignments = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/startTaskAssignments', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.completeTaskAssignments = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/completeTaskAssignments', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.assignTaskToQueue = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/updateTaskAssignmentQueue', null, {
            'update': { method: 'PUT' }
        })
    };

    factory.assignTasksToQueue = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/updateTaskAssignmentsQueue', null, {
            'update': { method: 'PUT' }
        })
    };

    factory.assignToCurrentUser = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/assignToCurrentUser', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.unassignTaskAssignment = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/unassign', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.followTaskAssignment = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/followTaskAssignment', null, {
            'save': { method: 'POST' }
        });
    };

    factory.followTaskAssignments = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/followTaskAssignments', null, {
            'save': { method: 'POST' }
        });
    };

    factory.unfollowTaskAssignment = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/unfollowTaskAssignment', null, {
            'save': { method: 'DELETE' }
        });
    };

    factory.unfollowTaskAssignments = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/unfollowTaskAssignments', null, {
            'save': { method: 'DELETE' }
        });
    };

    factory.completeTaskAssignment = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/completeTaskAssignment', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.rejectTaskAssignment = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/rejectTaskAssignment', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.incrementTaskAssignmentPriority = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/incrementTaskAssignmentPriority', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.incrementTaskAssignmentsPriority = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/incrementTaskAssignmentsPriority', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.decrementTaskAssignmentPriority = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/decrementTaskAssignmentPriority', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.decrementTaskAssignmentsPriority = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/decrementTaskAssignmentsPriority', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.executeVendorPush = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/executeVendorPush', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.executeGoalPush = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/executeGoalPush', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.processWebhookEvents = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/processWebhookEvents', null, {
            'update': { method: 'PUT' }
        });
    };

    factory.referenceTables = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/referenceTablesWithLabels', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.vendorsList = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/vendors', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.closedTaskAssignments = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/closedTaskAssignments', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };
    factory.openTaskAssignments = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/openTaskAssignments', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.tasksStatus = function() {
        return $resource(AppConfig.IO_API_URL + 'statuses/taskStatuses', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskStatusUpdate = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/updateTaskStatus', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.toggleTaskState = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/toggleTaskState', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.openLineItems = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/openLineItemsForTask', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.canCompleteTask = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/canCompleteTask', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.logTimeForTask = function() {
        return $resource(AppConfig.IO_API_URL + 'taskAssignmentTimelog/add', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.deleteTimelogEntry = function() {
        return $resource(AppConfig.IO_API_URL + 'taskAssignmentTimelog/delete', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.getTasksWithoutTaskForm = function() {
        return $resource(AppConfig.IO_API_URL + 'templates/tasksWithoutTaskForm', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.dueDateDependencies = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/getDueDateDependencies', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.updateTaskDueDate = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/:updateDueDate', null, {
            'update': {
                method: 'PUT',
                isArray: false
            }
        });
    };

    factory.getTaskAssignmentHistory = function(id) {
        return $resource(AppConfig.API_URL + 'taskassignment/' + id + '/history', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.addCalendarEvent = function(id) {
        return $resource(AppConfig.API_URL + 'nylas/addTaskEventCurrentUser/' + id, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.hasCalendarEvent = function(id) {
        return $resource(AppConfig.API_URL + 'task/hasCalendarAssociation/' + id, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    return factory;
}
